import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Typography } from '@telus-uds/components-web';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';

const SuccessMessage = ({ status }) => {
  const localizedStrings = useLocalizedStringsContext();
  const { 
    USERS:{
      USER_AUTHENTICATION: {
        USER_APRROVAL:{
          HEADING,
          SUCCESS_MESSAGE,
          CONGRATS,
          NOTE,
          FAILURE_MESSAGE,
          BUTTONS: {
            TITLE
          }
        }
      }
    }
  } = localizedStrings;
  return (
    <>
      <div id="main">
        <div id="main-wrapper">
          <div id="main-content">
            <Typography heading="h2" variant={{ size: 'h2' }}>
              <div id="main-content-title">
                <span
                  className="frg-icon icon-user-profile-inverted"
                  style={{ paddingRight: 10, fontSize: 26 }}
                />
                {HEADING}
              </div>
            </Typography>
            <div id="main-content-indicator">
              <div id="main-content-indicator-step-3"></div>
            </div>
            <div id="main-content-login">
              {status === '1' ? (
                <div id="email_sent" style={{ marginTop: 15 }}>
                  <span className="">
                    <b>{CONGRATS}</b> {SUCCESS_MESSAGE}
                  </span>
                </div>
              ) : (
                <div id="email_sent" style={{ marginTop: 15 }}>
                  <span>
                    <b>{NOTE}</b>: {FAILURE_MESSAGE}
                  </span>
                </div>
              )}
              <div style={{ marginTop: 20 }}>
                <span>
                  <Link
                    to="/login"
                    className="frg-button button-wide color-green"
                  >
                    {TITLE}
                  </Link>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

SuccessMessage.propTypes = {
  status: PropTypes.number.isRequired
};

export default SuccessMessage;
